<template>
  <span style="white-space: nowrap">
    <!-- actions outside menu -->
    <v-tooltip v-for="action in actionsNoMenu" :key="action.text" left>
      <template #activator="{ on }">
        <template v-if="action.to || action.href">
          <v-btn
            icon
            class="ma-0"
            :disabled="disabled || action.disabled"
            :to="action.to"
            :href="action.href"
            :target="action.target"
            v-on="on"
          >
            <v-icon small>{{ action.icon }}</v-icon>
          </v-btn>
        </template>
        <template v-else-if="action.action">
          <v-btn
            icon
            :disabled="disabled || action.disabled"
            :loading="action.loading"
            v-on="on"
            @click.stop="action.action($event, data)"
          >
            <v-icon small>{{ action.icon }}</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-btn icon class="ma-0" disabled>
            <v-icon small>{{ action.icon }}</v-icon>
          </v-btn>
        </template>
      </template>
      <span>{{ action.text }}</span>
    </v-tooltip>

    <!-- actions inside menu -->
    <!-- If there is only one item, we will display it normally -->
    <template v-if="actionsMenu.length === 1">
      <v-tooltip v-for="action in actionsMenu" :key="action.text" left>
        <template #activator="{ on }">
          <template v-if="action.to || action.href">
            <v-btn
              icon
              class="ma-0"
              :disabled="disabled || action.disabled"
              :to="action.to"
              :href="action.href"
              :target="action.target"
              v-on="on"
            >
              <v-icon small>{{ action.icon }}</v-icon>
            </v-btn>
          </template>
          <template v-else-if="action.action">
            <v-btn
              icon
              :disabled="disabled || action.disabled"
              :loading="action.loading"
              v-on="on"
              @click.stop="action.action($event, data)"
            >
              <v-icon small>{{ action.icon }}</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <v-btn icon small class="ma-0" disabled>
              <v-icon small>{{ action.icon }}</v-icon>
            </v-btn>
          </template>
        </template>
        <span>{{ action.text }}</span>
      </v-tooltip>
    </template>
    <!-- If there are more than one item, we will display it in a menue -->
    <template v-else-if="actionsMenu.length > 0">
      <v-menu bottom left>
        <template #activator="{ on }">
          <v-btn icon class="ma-0" :disabled="disabled" v-on="on">
            <v-icon small>$freshvue-options</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="action in actionsMenu"
            :key="action.text"
            :to="action.to ? action.to : null"
            :href="action.href"
            :target="action.target"
            :disabled="action.loading || disabled || action.disabled"
            @click.stop="action.action ? action.action($event, data) : null"
          >
            <v-list-item-action>
              <v-icon small>{{ action.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-title>{{ action.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <!-- If there is only one nothing at all (and we want a menu to be displayed), we will display a dummy element (for spacing) -->
    <template v-else-if="!noMenu">
      <v-btn icon class="ma-0" disabled style="visibility: hidden"></v-btn>
    </template>
  </span>
</template>

<script>
import {
  VTooltip,
  VBtn,
  VIcon,
  VMenu,
  VList,
  VListItem,
  VListItemAction,
  VListItemTitle
} from 'vuetify/lib'

export default {
  name: 'ListOptions',

  components: {
    VTooltip,
    VBtn,
    VIcon,
    VMenu,
    VList,
    VListItem,
    VListItemAction,
    VListItemTitle
  },

  props: {
    /*
      Possible Object for an action:

      {
        icon: '$action-send',
        text: 'E-Mail senden',
        action: this.onSendEmail,
        to: { name: 'home' },
        href: 'https://www.google.com/',
        target: '_blank', // only used if 'href' is set
        prefersVisible: true,
        hidden: !this.antrag, // OR function
        disabled: false,
        loading: false
      }
    */
    actions: {
      type: Array,
      required: true
    },
    maxVisible: {
      type: Number,
      required: false,
      default: 2
    },
    noMenu: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: null
    }
  },

  computed: {
    actionsNoMenu() {
      let items = this.actions
        .filter((item) => item.prefersVisible && !this.isItemHidden(item))
        .splice(0, this.maxVisible)

      if (items.length < this.maxVisible) {
        // We can add items which aren't prefering to be visible
        const diff = this.maxVisible - items.length
        const itemsAdditional = this.actions
          .filter((item) => !item.prefersVisible && !this.isItemHidden(item))
          .splice(0, diff)

        if (itemsAdditional.length > 0) {
          items = items.concat(itemsAdditional)
        }
      }

      return items
    },

    actionsMenu() {
      let items = this.actions
        .filter(
          (item) =>
            item.prefersVisible &&
            !this.isItemHidden(item) &&
            !this.actionsNoMenu.includes(item)
        )
        .splice(0, this.maxVisible)
        .concat(
          this.actions.filter(
            (item) =>
              !item.prefersVisible &&
              !this.isItemHidden(item) &&
              !this.actionsNoMenu.includes(item)
          )
        )

      return items
    }
  },
  methods: {
    isItemHidden(item) {
      if (typeof item.hidden === 'function') {
        return item.hidden(this.data)
      } else {
        return !!item.hidden
      }
    }
  }
}
</script>
